import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import { useSnackbar } from 'notistack';
import { routes } from "../../constants.js/misc";
import { MainContainer } from "./styles.popup";
import { colors } from "../../constants.js/colors";

const modalStyle = makeStyles({
  darkModal: {
    backgroundColor: colors.secondary.main,
  },
  whiteFont: {
    color: colors.white
  }
})

/* * AddProductModal component
 * Displays a modal to guide users to add their first product
 * @param {Object} props - Component properties
 * @param {boolean} props.openAddProduct - Controls the visibility of the modal
 * @param {boolean} props.disableEscapeKeyDown - Disables closing the modal with the escape key
 * @param {function} props.onAddProductClick - Callback function when the "Add Product" button is clicked
 */
const AddProductModal = ({ openAddProduct, disableEscapeKeyDown, onAddProductClick }) => {
  const history = useHistory();
  const classes = modalStyle();
  const { enqueueSnackbar } = useSnackbar();

  const handleAddProduct = () => {
    const blocked =
      typeof window !== 'undefined' &&
      window.sessionStorage.getItem('freemium-block-add-products') === '1';

    if (blocked) {
      enqueueSnackbar(
        'Tu plan Freemium permite hasta 20 productos. Mejora tu plan para agregar más.',
        { variant: 'info', autoHideDuration: 4000 }
      );
      onAddProductClick();
      return;
    }

    history.push(routes.createProduct);
    onAddProductClick();
  };

  return (
    <Dialog
      open={openAddProduct}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      <MainContainer
        className={classes.darkModal}
      >
        <Typography variant="h3" className={classes.whiteFont}>
          <span role="img" aria-label="party">
            🎉
          </span>
          ¡Felicitaciones!
        </Typography>
        <Typography variant="h6" className={classes.whiteFont}>
          Has comenzado tu prueba gratuita de 7 días.
        </Typography>
        <Typography variant="h6" className={classes.whiteFont}>
          Mira este video para aprender cómo empezar a vender con Ecometri.
        </Typography>
        <iframe
          width="360"
          height="300"
          src="https://www.youtube-nocookie.com/embed/oWInN0iyz70?rel=0&modestbranding=1"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <Button variant="contained" color="primary" onClick={handleAddProduct}>
          Agregar mi primer producto
        </Button>
      </MainContainer>
    </Dialog>
  );
}

export default AddProductModal;